module.exports = __webpack_public_path__ + "img/skyvpn.c17775ed.png";